import React, { useContext, useState } from 'react'
import { DataContext } from '../../context/DataContext'
import PickupMap from './PickupMap'
import {
  Spinner
} from '@pinflag/pinflag-ui-kit'
import { useApiPinflag } from '../../hook/useApiPinflag'

export default function PickupMapStep () {
  const [isLoading, setIsLoading] = useState(false)
  const {
    steps,
    setSteps,
    setIsPickup
  } = useContext(DataContext)

  const { getPoints } = useApiPinflag()

  const reloadPoints = () => {
    setIsLoading(true)
    getPoints(setIsLoading)
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    updatedSteps[1].subSteps[0].completed = true

    setIsPickup(false)
    setSteps(updatedSteps)
  }

  if (isLoading) {
    return (
      <div className='flex flex-col gap-y-4 justify-center items-center mb-10'>
        <Spinner />
      </div>
    )
  }
  return (
    <PickupMap reloadPoints={reloadPoints} />
  )
}
